import { Box } from '@wix/design-system';
import {
  useIsStudioNewUi,
  useLocalization,
} from '@wix/package-picker-shared-studio';
import { FeaturesGrid as PlatformFeaturesGrid } from '@wix/premium-purchase-platform/@components';
import { CreativeOffer } from '@wix/premium-purchase-platform/@sdk';
import { ConfirmSmall, MinusSmall } from '@wix/wix-ui-icons-common/odeditor';
import classNames from 'classnames';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import styles from './FeaturesGrid.scss';

interface FeaturesGridFeatureRowValueProps {
  comparisonValue?: CreativeOffer.ComparisonValue;
}

export const FeaturesGridFeatureRowValue = ({
  comparisonValue,
}: FeaturesGridFeatureRowValueProps) => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();
  const { shouldShowJapaneseExperience } = useLocalization();
  const isStudioNewUi = useIsStudioNewUi();

  if (comparisonValue?.available && comparisonValue?.value?.translationKey) {
    return (
      <PlatformFeaturesGrid.Content.FeatureRow.Value
        value={t(comparisonValue.value.translationKey)}
      />
    );
  }

  if (isStudioNewUi) {
    return (
      <Box align="center">
        {comparisonValue?.available ? (
          <ConfirmSmall />
        ) : (
          <MinusSmall className={styles.mutedMinusIcon} />
        )}
      </Box>
    );
  }

  return (
    <PlatformFeaturesGrid.Content.FeatureRow.Value
      classNames={{
        checkIcon: classNames(styles.checkIcon, {
          [styles.japan]: shouldShowJapaneseExperience,
        }),
        minusIcon: styles.minusIcon,
      }}
      value={!!comparisonValue?.available}
    />
  );
};
